export default __webpack_public_path__ + "static/media/925.a87a244e.gif";